import { TextFieldProps } from '@material-ui/core';
import { forwardRef } from 'react';
import { TextField } from './styles';
import { ColSpan } from '../types';

export type InputRootProps = TextFieldProps & {
  colspan?: ColSpan;
  format?: string;
  absoluteHelperText?: boolean;
  hideHelperText?: boolean;
};

export const InputRoot = forwardRef<HTMLDivElement, InputRootProps>(
  ({ colspan, format, absoluteHelperText, hideHelperText, ...props }, ref) => {
    return (
      <TextField
        {...props}
        ref={ref}
        $colspan={colspan}
        $absoluteHelperText={absoluteHelperText}
        $hideHelperText={hideHelperText}
      />
    );
  },
);
